(function () {
  'use strict';

  const drawer = document.getElementById('vb-drawer');
  if (!drawer) return;

  const panel = drawer.querySelector('.vb-drawer__panel');
  const views = drawer.querySelectorAll('.vb-drawer__panel-view');
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  // Clone topbar info blocks into the drawer (single source of truth)
  const infosTemplate = document.getElementById('vb-drawer-infos-template');
  const infosMount = drawer.querySelector('[data-vb-drawer-infos-mount]');
  if (infosTemplate && infosMount) {
    const items = infosTemplate.content.cloneNode(true);
    if (items.children && items.children.length > 0) {
      infosMount.appendChild(items);
      const wrapper = drawer.querySelector('.vb-drawer__infos-mount');
      if (wrapper) wrapper.hidden = false;
    }
  }

  let scrollY = 0;

  function lockBodyScroll() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
  }

  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    showView('main');
    lockBodyScroll();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockBodyScroll();
    setTimeout(() => showView('main'), 300);
  }

  function showView(name) {
    views.forEach((v) => v.classList.toggle('is-active', v.dataset.vbDrawerView === name));
    if (panel) panel.scrollTop = 0;
  }

  // Hijack the Horizon hamburger button on mobile
  document.addEventListener(
    'click',
    (e) => {
      if (!isMobile()) return;
      const summary = e.target.closest('.menu-drawer-container > summary');
      if (summary) {
        e.preventDefault();
        e.stopPropagation();
        const details = summary.parentElement;
        if (details && details.open) details.open = false;
        open();
      }
    },
    true
  );

  drawer.addEventListener('click', (e) => {
    const region = e.target.closest('[data-vb-region]');
    if (region) {
      const form = region.closest('form.vb-drawer__regions-form');
      if (form) {
        e.preventDefault();
        const country = region.getAttribute('data-country');
        const lang = region.getAttribute('data-language');
        const countryInput = form.querySelector('[data-vb-region-country]');
        const langInput = form.querySelector('[data-vb-region-language]');
        if (country && countryInput) countryInput.value = country;
        if (lang && langInput) langInput.value = lang;
        form.submit();
        return;
      }
    }
    if (e.target.closest('[data-vb-drawer-close]')) {
      close();
      return;
    }
    const drillBtn = e.target.closest('[data-vb-drawer-drill]');
    if (drillBtn) {
      showView(drillBtn.dataset.vbDrawerDrill);
      return;
    }
    if (e.target.closest('[data-vb-drawer-back]')) {
      showView('main');
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();
